
webpack.register(
    'modules/video-landing/video-landing',
    function() {
        return import('modules/video-landing/video-landing');
    },
    true
);